import React, { createContext, useContext, useState, useEffect } from 'react'
import { getMe, login as apiLogin } from '../utils/api'

const AuthContext = createContext(null)

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const initAuth = async () => {
      const token = localStorage.getItem('token')
      if (token) {
        try {
          const res = await getMe()
          setUser(res.data)
        } catch (err) {
          localStorage.removeItem('token')
        }
      }
      setLoading(false)
    }
    initAuth()
  }, [])

  useEffect(() => {
    const onUnauthorized = () => {
      localStorage.removeItem('token')
      setUser(null)
    }
    window.addEventListener('api:unauthorized', onUnauthorized)
    return () => window.removeEventListener('api:unauthorized', onUnauthorized)
  }, [])

  // 🪤 Modified to accept the honeypot field 'confirmEmail'
  const login = async (email, password, confirmEmail = '') => {
    // Pass confirmEmail to your apiLogin utility
    const res = await apiLogin(email, password, confirmEmail)
    const token = res.data.access_token
    localStorage.setItem('token', token)
    const userRes = await getMe()
    setUser(userRes.data)
    return userRes.data
  }

  const logout = () => {
    localStorage.removeItem('token')
    setUser(null)
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)